<div class="banner">
    
    <div class="banner-container">
    <div class="banner-img" [attr.data-banner]="0"></div> 
     <!-- <img class="banner-img" src="../../assets/img/sample1351_560.png" >
     <img class="banner-img" src="../../assets/img/sample1351_560.png" > -->
    </div>
  
      <div class="frankyFavourite">
          Frranky's Favourite
      </div>
      <div class="content">
        <div *ngFor="let product of malePlain" >
            <img  [src]="product.productImage" class="productTshirt"  (click)="viewProduct(product)">
            <p class="tshirtImageDesc" >{{product.productName}}</p>
           
            
             <!-- <p *ngFor="let tshirtdesc of tshirtsDesc">{{tshirtdesc}}</p> -->
          </div>
          <!-- <div>
              <img src="../../assets/img/tshirt1.jpg" class="tshirt">
          </div>
          <div>
              <img src="../../assets/img/tshirt1.jpg" class="tshirt">
          </div>
          <div>
              <img src="../../assets/img/tshirt1.jpg" class="tshirt">
          </div> -->
          
      </div>
    </div>
